<mat-toolbar class="flex justify-between">
  <div class="flex">
    <span>{{login.dbname}}</span>
    <span>公司:{{login.companyItem.name}}</span><span>主機:{{login.hostName}}</span>
  </div>
</mat-toolbar>

<!--
<div #header>
  <table class="w-full">
    <tr>
      <td class="w-1/3">
          <button mat-mini-button color="primary" (click)="doShowLeftMenu()" >
            <mat-icon>menu</mat-icon>
          </button>

      </td>
      <td class="w-1/3 text-center">
        <div><h4>首頁</h4></div>
      </td>
      <td class="w-1/3 ">
        <button mat-mini-button color="primary" [matMenuTriggerFor]="menu" >
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </tr>
  </table>
</div> -->
